const API_URL = "https://app.tavad.com/hce/wp-json";

export async function auth(username, password) {
  const credentials = {
    username,
    password,
  };
  try {
    const response = await fetch(`${API_URL}/jwt-auth/v1/token`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials),
    } );
    const data = await response.json();

    if ((typeof data.token !== "undefined") && (typeof data.user_nicename  !== "undefined")) {

		sessionStorage.setItem( 'token', data.token );
		sessionStorage.setItem( 'userName', data.user_nicename );

    }

    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}

const logout = () => {
  sessionStorage.removeItem("token");
};

const getCurrentUser = () => {
  return JSON.parse(sessionStorage.getItem("token"));
};

const authService = {
  logout,
  getCurrentUser,
};
